import api from "../../../../veracityapi";
import { todayFinisihedSessions } from "../../../../Redux/actions";
import moment from "moment";
import "moment-timezone";
import { act } from "react";
// import { getStartTimeStampFromString, getEndTimeStampFromString } from "../../../../SharedComponents/DateManager";


export default function Data(params, dispatch) {
	const websiteGUID = localStorage.getItem('selected_site');
	const timeZone = localStorage.getItem('timezone');
	const startTime = moment().tz(timeZone).startOf('day').unix();
	const endTime = moment().tz(timeZone).endOf('day').unix();

	// const start = getStartTimeStampFromString(timeRange);
	// const end = getEndTimeStampFromString(timeRange);

	const getTodayFinishedSessionsData = new Promise((resolve, reject) => {
		api.GET(`/analytics/${websiteGUID}/realtime/finished/${startTime}/${moment().tz(timeZone).add({ days: 1 }).endOf('day').unix()}`)
			.then(res => {
				resolve({
					todayFinisihedSessions: res.item
				});
			}).catch((error) => {
				api.handleError(error);
			});
	});

	const getGeographicalSessionData = new Promise((resolve, reject) => {
		api.GET(`/session/website/${websiteGUID}/doublebreakdown/country/${startTime}/${endTime}/hour-by-hour/bot/`, {active: false, finished: true })
			.then(res => {
				const botTotals = {bot: {other: 0}};
				for (const date in res.item) {
					for(const [key, value] of Object.entries(res.item[date].bot)) {
						if(key !== 'total')  botTotals.bot[key] = (botTotals.bot[key] || 0) + value;
					}
				}
				resolve({
					finishedSessionsByCountry: res.item,
					finishedBlockedBots: botTotals
				});
			}).catch((error) => {
				api.handleError(error);
			});
	});
	const getSessionReferrer = new Promise((resolve, reject) => {
		api.GET(`/session/website/${websiteGUID}/doublebreakdown/referrer/${startTime}/${endTime}/hour-by-hour/bot/`, {active: false, finished: true })
			.then(res => {
				resolve({
					finishedSessionsReferrer: res.item
				});
			}).catch((error) => {
				api.handleError(error);
			});
	});
	const getTodaySessionsBrowsers = new Promise((resolve, reject) => {
		api.GET(`/session/website/${websiteGUID}/doublebreakdown/browser/${startTime}/${endTime}/hour-by-hour/bot/`, {active: false, finished: true }).then(res => {			
			resolve({
				todaySessionsBrowsers: res.item
			});
		}).catch((error) => {
			api.handleError(error);
		});
	});

	const getTodaySessionsOS = new Promise((resolve, reject) => {
		api.GET(`/session/website/${websiteGUID}/doublebreakdown/os/${startTime}/${endTime}/hour-by-hour/bot/`, {active: false, finished: true }).then(res => {

			resolve({
				todaySessionsOS: res.item
			});
		}).catch((error) => {
			api.handleError(error);
		});
	});

	return new Promise((resolve, reject) => {
		Promise.all([getTodayFinishedSessionsData, getGeographicalSessionData, getSessionReferrer, getTodaySessionsBrowsers, getTodaySessionsOS]).then(async (values) => {
			const temp = {
			};
			for (let obj of values) {
				Object.assign(temp, obj);
			};
			dispatch(todayFinisihedSessions(temp));
			resolve(true);
		}).catch((error) => {
             reject(error)
        });
	});
};